import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

const superListStoreConfig = {
  id: 'superListStore',
  initialState: {
    tableCondition: {},
    filterCondition: {},
    listInfo: {},
    recordsData: {}
  },
  methods: (set, get) => ({
    // Setter for tableCondition
    setTableCondition: (tableName, viewId, data) => {
      if (!tableName || !viewId) return;
      const allTableCondition = get().tableCondition || {};
      const tableCondition = allTableCondition?.[tableName] || {};
      const updatedTableCondition = {
        ...allTableCondition,
        [tableName]: {
          ...tableCondition,
          [viewId]: data
        }
      };
      set({ tableCondition: updatedTableCondition });
    },

    // Setter for filterCondition
    setFilterCondition: (tableName, viewId, data) => {
      if (!tableName || !viewId) return;
      const allFilterCondition = get().filterCondition || {};
      const filterCondition = allFilterCondition?.[tableName] || {};
      const updatedFilterCondition = {
        ...allFilterCondition,
        [tableName]: {
          ...filterCondition,
          [viewId]: data
        }
      };
      set({ filterCondition: updatedFilterCondition });
    },

    // Setter for listInfo
    setListInfo: (tableName, viewId, data) => {
      if (!tableName || !viewId) return;

      const allListInfo = get().listInfo || {};
      const tableListInfo = allListInfo?.[tableName] || {};
      const updatedListInfo = {
        ...allListInfo,
        [tableName]: {
          ...tableListInfo,
          [viewId]: data
        }
      };
      set({ listInfo: updatedListInfo });
    },

    getTableCondition: (tableName, viewId) => {
      if (!tableName || !viewId) return undefined;

      const state = get();
      return state?.tableCondition?.[tableName]?.[viewId];
    },

    getFilterCondition: (tableName, viewId) => {
      if (!tableName || !viewId) return undefined;

      const state = get();
      return state?.filterCondition?.[tableName]?.[viewId];
    },

    getListInfo: (tableName, viewId) => {
      if (!tableName || !viewId) return undefined;

      const state = get();
      return state?.listInfo?.[tableName]?.[viewId];
    },

    getRecords: (tableName, viewId) => {
      if (!tableName || !viewId) return undefined;

      const state = get();
      return state?.records?.[tableName]?.[viewId] || null;
    },

    // Clear all data for a specific table
    // TODO: FIX THIS
    clearAllTableData: (tableName) => {
      if (!tableName) return;

      const state = get();
      const { tableCondition, filterCondition, listInfo, records } = state;

      const newTableCondition = { ...tableCondition };
      const newFilterCondition = { ...filterCondition };
      const newListInfo = { ...listInfo };
      const newRecords = { ...records };

      // Delete the entire table entry
      delete newTableCondition[tableName];
      delete newFilterCondition[tableName];
      delete newListInfo[tableName];
      delete newRecords[tableName];

      set({
        tableCondition: newTableCondition,
        filterCondition: newFilterCondition,
        listInfo: newListInfo,
        records: newRecords
      });
    },

    // Clear data for a specific table and viewId
    // TODO: FIX THIS

    clearTableWithViewId: (tableName, viewId) => {
      if (!tableName || !viewId) return;

      const state = get();
      const { tableCondition, filterCondition, listInfo, records } = state;

      const newTableCondition = { ...tableCondition };
      const newFilterCondition = { ...filterCondition };
      const newListInfo = { ...listInfo };
      const newRecords = { ...records };

      if (newTableCondition?.[tableName]) {
        newTableCondition[tableName] = { ...newTableCondition[tableName] };
        delete newTableCondition[tableName][viewId];
      }

      if (newFilterCondition?.[tableName]) {
        newFilterCondition[tableName] = { ...newFilterCondition[tableName] };
        delete newFilterCondition[tableName][viewId];
      }

      if (newListInfo?.[tableName]) {
        newListInfo[tableName] = { ...newListInfo[tableName] };
        delete newListInfo[tableName][viewId];
      }

      if (newRecords?.[tableName]) {
        newRecords[tableName] = { ...newRecords[tableName] };
        delete newRecords[tableName][viewId];
      }

      set({
        tableCondition: newTableCondition,
        filterCondition: newFilterCondition,
        listInfo: newListInfo,
        records: newRecords
      });
    },

    // Setter for records
    setRecords: (tableName, viewId, data) => {
      if (!tableName || !viewId) return;

      const allRecords = get().records || {};
      const records = allRecords?.[tableName] || {};
      const updatedRecords = {
        ...allRecords,
        [tableName]: {
          ...records,
          [viewId]: data
        }
      };

      set({ records: updatedRecords });
    },

    // Reset all filters
    resetAllFilters: (
      tableName,
      viewId,
      resetToDefaultAdvanceFilter,
      defaultAdvanceFilter
    ) => {
      if (!tableName || !viewId) return;

      const tableCondition = get().tableCondition || {};
      const filterCondition = get().filterCondition || {};

      const currentTableCondition = tableCondition?.[tableName] || {};
      const currentFilterCondition = filterCondition?.[tableName] || {};

      if (currentTableCondition?.[viewId]) {
        currentTableCondition[viewId] = null;
      }

      if (currentFilterCondition?.[viewId]) {
        if (resetToDefaultAdvanceFilter) {
          currentFilterCondition[viewId] = defaultAdvanceFilter;
        } else {
          currentFilterCondition[viewId] = null;
        }
      }

      set({
        tableCondition: {
          ...tableCondition,
          [tableName]: currentTableCondition
        },
        filterCondition: {
          ...filterCondition,
          [tableName]: currentFilterCondition
        }
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useSuperListStore = createStore(superListStoreConfig);
